import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import './style.css';

const Notifcation = ({ isOpen, onClose, content}) => {
  const formatMessage = (item) => {
    const styledMessage = item?.replace(
      /<img /g,
      '<img style="max-width:460px;" '
    );
    return styledMessage
  }
    return (
      <Modal size="md" show={isOpen} onHide={onClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Notification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {content?.map((item, index) => (
              <div key={index} className="mb-3">
              <div style={{fontSize:"14px", fontWeight:"bold"}}>{item.title}</div>  
               <div style={{marginTop:"9px", maxWidth:"500px"}}> <div  dangerouslySetInnerHTML={{ __html: formatMessage(item?.message) }} /></div>
             </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer style={{display:"flex", justifyContent:"end"}}>
          <div style={{width:"200px", display:"flex", justifyContent:"end", alignItems:"end"}}>
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
          </div>
          
        </Modal.Footer>
      </Modal>
    );
  };
  export default Notifcation;